import { render, staticRenderFns } from "./FormQuestionTrueFalseType.vue?vue&type=template&id=4b5e3797"
import script from "./FormQuestionTrueFalseType.vue?vue&type=script&lang=js"
export * from "./FormQuestionTrueFalseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports